import { isPlainObject, isEmpty, get, isNil } from 'lodash';

export default ({ initialValues, pristine }, valuePath = 'value') => {
  const value = get(initialValues, valuePath);
  if (isPlainObject(value)) {
    return isEmpty(value) && pristine;
  }
  return pristine && isNil(value);
};
